import { showAuth } from 'Lib/show-auth/show-auth';
import { speed } from 'Lib/speed/speed';
import { eksmoBP } from 'Lib/bp/bp';
import { getW } from 'Lib/w/w';

const $collectionManagement = $('.collection-management');
const cActive = 'collection-management_active';
const $html = $('html');
let timeoutCollection = 0;

if (!$html.hasClass('is-authorized')) {
    $collectionManagement.find('.collection-management__btn').removeClass('js-btn-m-menu');
}

// Добавление списка подборок на карточку книги
$collectionManagement.on('click', function (e) {
    const $this = $(this);

    if ($html.hasClass('is-authorized')) {
        if (e.target.classList.contains('collection-management__btn') && getW() > eksmoBP.mdMin) {
            if (!$this.hasClass(cActive)) {
                $this.addClass(cActive);
            } else {
                $this.removeClass(cActive);
            }
        }
    } else {
        showAuth();
    }
});

$('body').on('collectionAdd.eksmo', (e, $th, bookId, collectionId) => {
    $.ajax({
        type: 'POST',
        url: '/ajax/user-collections/book/',
        data: { id: collectionId, checked: true, book_id: bookId },
        dataType: 'json',
        success: (data) => {
            if (typeof data.error === 'string') {
                showError(data.error);
            } else {
                $th.text('Готово');
            }
        },
        error: () => {
            showError('Попробуйте еще раз или обратитесь в службу технической поддержки.');
        },
    });

    function showError(error) {
        $.fancybox.open(`<div><p class="text text_c-gray">Ошибка</p><p>"${error}"</p></div>`);
    }
});

// Изменение чекбокса подборок
$collectionManagement.on('eksmoChangeCheckbox', '.collection-management__checkbox', function (e, checked) {
    const $this = $(this);
    const collectionId = $this.attr('data-collection-id');
    const $menuBlock = $this.closest('.collection-management__item-checkbox-box');
    const cMenuBlockLoading = 'collection-management__item-checkbox-box_loading';
    const $loader = $menuBlock.find('.collection-management__loader');
    const $message = $this.closest('.book-page__collection').find('.collection-management__collection-tip');
    const $messageAdd = $this.closest('.book-page__collection').find('.collection-management__collection-tip[data-message="add"]');
    const $messageDel = $this.closest('.book-page__collection').find('.collection-management__collection-tip[data-message="del"]');
    const bookId = $this.closest('.book-page').attr('data-book-id') || $this.closest('.book').attr('data-id');

    $collectionManagement.addClass(cMenuBlockLoading);
    $loader.show();

    $.ajax({
        type: 'POST',
        url: '/ajax/user-collections/book/',
        data: { id: collectionId, checked, book_id: bookId },
        dataType: 'json',
        success: (data) => {
            if (typeof data.error === 'string') {
                showError(data.error, $this);
            } else {
                clearTimeout(timeoutCollection);
                $message.fadeOut(speed);

                if (checked) {
                    $('body').trigger('addBookCollections.eksmo', [$this]);
                    $messageAdd.fadeIn(speed);
                } else {
                    $messageDel.fadeIn(speed);
                }

                timeoutCollection = setTimeout(() => {
                    $message.fadeOut(speed);
                }, 3000);
            }
        },
        error: () => {
            showError('Попробуйте еще раз или обратитесь в службу технической поддержки.', $this);
        },
        complete: () => {
            $collectionManagement.removeClass(cMenuBlockLoading);
            $loader.hide();
        },
    });

    function showError(error, collection) {
        $.fancybox.open(`<div><p class="text text_c-gray">Ошибка</p><p>"${error}"</p></div>`);
        collection.find('input').prop('checked', !checked);
    }
});

// Добавление подборки
$collectionManagement.on('eksmoCollectionUserAdd', function (e, text, id) {
    const $this = $(this).find('.collection-management__item-checkbox-box');
    let mewCollectionMenuItem =
        `<div class="collection-management__item">
            <label class="collection-management__checkbox checkbox" data-collection-id="${id}" data-dmp-event="click-add-to-collection">
                <input type="checkbox">
                <span class="checkbox__button"></span>
                <span class="checkbox__content-offset">${text}</span>
            </label>
        </div>`;

    if ($this.hasClass('m-menu__submenu-cont')) { // Мобилка
        mewCollectionMenuItem =
            `<label class="m-menu__s-item">
                <div class="m-menu__s-item-text">${text}</div>
                <div class="m-menu__s-item-control">
                    <label class="checkbox book-page__collection-menu-item" data-collection-id="${id}">
                        <input type="checkbox">
                        <span class="checkbox__button checkbox__button_no-offset checkbox__button_no-bg"></span>
                    </label>
                </div>
            </label>`;
    }

    $this.append(mewCollectionMenuItem);
});

// Изменение текстового поля добавления подборки
$(document).on('change keyup paste', '.collection-management__input', function () {
    const $this = $(this);
    const $btn = $this.closest('.collection-management__form').find('.collection-management__form-btn');
    const cBtnDisabled = 'btn_disabled';

    if ($this.val().length > 0) {
        $btn.removeClass(cBtnDisabled).prop('disabled', false);
    } else {
        $btn.addClass(cBtnDisabled).prop('disabled', true);
    }
});

// клик на кнопку "Создать подборку"
$(document).on('eksmoThisAjaxFormSuccess', '.collection-management__form', function (e, message, data) {
    const $this = $(this);
    const inputVal = $this.find('.collection-management__input').val();

    if ($this.hasClass('collection-management__form_personal')) {
        window.location.reload(true);
    } else {
        if (data) {
            if (data.DATA) {
                const id = data.DATA.ID;

                if (typeof inputVal === 'string' && typeof id === 'string') {
                    $this.closest('.collection-management').trigger('eksmoCollectionUserAdd', [inputVal, id]);
                }
            } else {
                $.fancybox.close();

                $.fancybox.open(`
                    <div>
                        <p class="text text_c-gray">Ошибка получения данных</p>
                        <p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p>
                    </div>
                `);
            }
        }

        $this.find('.collection-management__input').val('');
        $this.removeClass('ajax-form_success');
        $this.find('.collection-management__form-btn').addClass('btn_disabled').prop('disabled', true);
    }
})
    .on('eksmoThisAjaxFormFail', (e, message) => {
        $.fancybox.close();

        if (typeof message === 'string') {
            $.fancybox.open(`<div><p class="text text_c-gray">Ошибка</p><p>"${message}"</p></div>`);
        } else {
            $.fancybox.open(`
                <div>
                    <p class="text text_c-gray">Ошибка связи с сервером</p>
                    <p>Попробуйте еще раз или обратитесь в службу технической поддержки.</p>
                </div>
            `);
        }
    });